import { useEffect, useState } from 'react';
import type { AiRoleRow, AiUsageReport } from '@kassa/shared';
import { api, ApiError } from '../../api';

const LOCK_LABEL: Record<NonNullable<AiRoleRow['lockReason']>, string> = {
  owner: 'sahib',
  own_role: 'sizin rolunuz',
};

// «AI köməkçi» (KT-68): hər rol üçün açıq/bağlı. Sahib və öz rolu kilidlidir (qaydanı baza da yoxlayır).
export function AiAccessPanel() {
  const [roles, setRoles] = useState<AiRoleRow[]>([]);
  const [busyRole, setBusyRole] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [usage, setUsage] = useState<AiUsageReport | null>(null);

  useEffect(() => {
    api
      .aiRoles()
      .then(setRoles)
      .catch((err: unknown) => setError(err instanceof ApiError ? err.message : 'Rollar yüklənmədi'));
  }, []);

  const toggle = async (role: AiRoleRow) => {
    setBusyRole(role.roleId);
    setError(null);
    try {
      await api.setAiRole(role.roleId, !role.enabled);
      setRoles((prev) => prev.map((r) => (r.roleId === role.roleId ? { ...r, enabled: !r.enabled } : r)));
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Dəyişmədi');
    } finally {
      setBusyRole(null);
    }
  };

  const loadUsage = () => {
    setError(null);
    api
      .aiUsage()
      .then(setUsage)
      .catch((err: unknown) => setError(err instanceof ApiError ? err.message : 'Hesabat yüklənmədi'));
  };

  return (
    <section className="card" aria-label="AI köməkçi">
      <h2>AI köməkçi</h2>
      <p className="muted small">AI yalnız açıq olan rollara görünür. Standartda kassir və anbardar bağlıdır.</p>
      <ul className="product-list">
        {roles.map((r) => (
          <li key={r.roleId} className="product-row">
            <span className="product-name">
              <input
                type="checkbox"
                aria-label={`${r.name} — AI köməkçi`}
                checked={r.enabled}
                disabled={r.locked || busyRole !== null}
                onChange={() => toggle(r)}
              />{' '}
              {r.name}
            </span>
            {r.lockReason && <span className="tag">{LOCK_LABEL[r.lockReason]}</span>}
            <span className="muted small">{r.enabled ? 'AI açıqdır' : 'AI bağlıdır'}</span>
          </li>
        ))}
      </ul>

      <button type="button" className="link-btn" onClick={loadUsage}>
        AI xərc hesabatı (bu ay)
      </button>
      {usage && (
        <div>
          <p className="muted small">
            {usage.month}: cəmi {usage.totalAzn} ₼
          </p>
          <ul className="product-list">
            {usage.rows.map((row) => (
              <li key={`${row.membershipId}-${row.feature}`} className="product-row">
                <span className="product-name">
                  {row.name} — {row.feature}
                </span>
                <span className="muted small">
                  {row.calls} çağırış · {row.tokensIn + row.tokensOut} token · {row.costAzn} ₼
                </span>
              </li>
            ))}
          </ul>
          {usage.rows.length === 0 && <p className="muted">Bu ay AI istifadəsi yoxdur.</p>}
        </div>
      )}

      {error && (
        <p className="bad" role="alert">
          {error}
        </p>
      )}
    </section>
  );
}
